export default {
  updateComments (state, comments = {}) {
    state.comments = {...state.comments, ...comments}
  },
}